module.exports = __webpack_public_path__ + "img/icon-unavailable.a17fbe60.svg";